import { CSSProperties, ReactNode } from 'react';
// form
import { FormProvider as ReactHookFormProvider, UseFormReturn } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  sx?: CSSProperties;
  formId?: string;
  className?: string;
};

export default function FormProvider({
  children,
  onSubmit,
  methods,
  sx,
  formId,
  className,
  ...props
}: Props) {
  return (
    <ReactHookFormProvider {...methods}>
      <form onSubmit={onSubmit} style={sx} id={formId} {...props} className={className}>
        {children}
      </form>
    </ReactHookFormProvider>
  );
}
